import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import { ScanRequestTableModel } from '../../../../shared/models/scan-request-table-model';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import { selectActiveScanRequestId, setActiveScanRequestId } from '../../store/scan-requests-slice';
import styles from './scan-requests-list.module.css';

interface Props {
  isFetchingScanRequests: boolean;
  scanRequestsDataSource: ScanRequestTableModel[];
}

const ScanRequestsList = ({ isFetchingScanRequests, scanRequestsDataSource }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();
  const activeScanRequestId = useAppSelector(selectActiveScanRequestId);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <List
      loading={isFetchingScanRequests}
      bordered={true}
      itemLayout="vertical"
      dataSource={scanRequestsDataSource}
      renderItem={record => (
        <List.Item
          className={styles.listItem}
          onClick={() => {
            if (activeScanRequestId === record.id) {
              // Deselect the item when clicked on active
              dispatch(setActiveRequestId(null));
              dispatch(setActiveScanRequestId(null));
              return;
            }

            navigate(Routes.ScanRequest.replace(':scanRequestId', record.id).replace(':requestId', record.request.id), {
              state: { from: location },
            });
            dispatch(setActiveRequestId(record.request.id));
            dispatch(setActiveScanRequestId(record.id));
          }}
        >
          <div>
            <Typography.Text strong>{t('label.name')}: </Typography.Text>
            {record.name}
          </div>
          <div>
            <Typography.Text strong>{t('label.user')}: </Typography.Text>
            {record.user}
          </div>
          <div>
            <Typography.Text strong>{t('signScanRequest.label.scannedAt')}: </Typography.Text>
            {record.scannedAt}
          </div>
        </List.Item>
      )}
    />
  );
};
export default ScanRequestsList;
